/**
 * Английский набор строк.
 */

import type { Strings } from './index';

export const en: Strings = {
  login_title: 'Sign in to CargoPASS',
  login_phone_label: 'Phone number',
  login_code_request: 'Get the code',
  login_code_label: 'Code from the message',
  login_code_submit: 'Sign in',
  login_failed: 'Signing in failed. Please try again.',
  works_title: 'Works',
  works_more: 'Show more',
  works_failed: 'The list could not be loaded.',

  // Ключи блока `WEB-1.1`: оболочка кабинета, четыре состояния экрана, вторая
  // ветка входа и согласие с условиями. Юридического текста условий здесь нет
  // ни в одном виде — его пишет человек, а временная строка была бы заглушкой.
  login_channel_phone: 'By phone',
  login_channel_email: 'By email',
  login_email_label: 'Email address',
  login_terms_label: 'I accept the terms of use',
  company_switcher_label: 'Company',
  language_label: 'Language',
  state_loading: 'Loading…',
  state_empty: 'Nothing here yet',
  state_error: 'The data could not be loaded',
  state_no_access: 'This page is not available to you',
  no_membership_title: 'You are not a member of any company',
  no_membership_explain: 'To start working, join a company or create your own.',
  company_create_submit: 'Create a company',
  company_name_label: 'Company name',
  company_form_type_label: 'Company type',
  company_tax_id_label: 'Registration number',
  company_legal_address_label: 'Legal address',
  company_members_title: 'Company members',
  not_found_title: 'No such page',

  // Ключи блока `WEB-1.2`: профиль пользователя, сотрудники, права, профиль
  // фирмы и документы. Подписи значений перечней собираются строителями ключа
  // из значения, пришедшего с сервера, и потому на экране литералом не стоят.
  profile_title: 'My profile',
  profile_sessions_title: 'Active sessions',
  profile_session_current: 'Current session',
  profile_session_never_used: 'Never used',
  profile_session_created: 'Created',
  profile_session_last_used: 'Last sign-in',
  profile_session_terminate: 'Terminate',
  profile_channel_add: 'Add a contact channel',
  profile_channel_code_request: 'Send the code',
  profile_channel_confirm: 'Confirm the channel',
  members_title: 'Staff',
  members_invite: 'Invite a member',
  invite_channel_phone: 'By phone',
  invite_channel_email: 'By email',
  invite_role_label: 'Role',
  invite_submit: 'Send the invitation',
  invitations_title: 'Invitations',
  invitation_revoke: 'Revoke',
  invitation_resend: 'Send again',
  rights_title: 'Member rights',
  rights_grants: 'Granted on top of the role',
  rights_denies: 'Denied personally',
  rights_grant_add: 'Grant a right',
  rights_deny_add: 'Set a denial',
  rights_remove: 'Remove',
  company_profile_title: 'Company profile',
  company_documents_title: 'Company documents',
  company_type_transport: 'Carrier',
  company_type_logistics: 'Logistics company',
  member_documents_title: 'Member documents',
  document_download: 'Open the file',
  enum_unknown: 'Unknown',
  role_director: 'Director',
  role_logist: 'Logistician',
  role_dispatcher: 'Dispatcher',
  role_accountant: 'Accountant',
  role_mechanic: 'Mechanic',
  role_driver: 'Driver',
  member_status_active: 'Active',
  member_status_closed: 'Closed',
  permission_company_staff_manage: 'Manage staff',
  permission_company_rights_manage: 'Manage rights',
  permission_company_fleet_manage: 'Manage the fleet',
  permission_company_fleet_repair: 'Mark a repair',
  permission_company_docs_manage: 'Manage documents',
  permission_company_listings_manage: 'Manage listings',
  permission_company_cargo_take: 'Take cargo',
  // РОСТ 0.9.30 (BE-2.4, шаг CONTRACT; решение D525): восьмое право каталога — привязка транспорта и водителя.
  permission_company_works_assign: 'Assign vehicle and driver',
  permission_company_accounting_manage: 'Manage company expenses and payouts',
  document_status_pending: 'Under review',
  document_status_verified: 'Verified',
  document_status_rejected: 'Rejected',
  document_status_expired: 'Expired',
  document_status_not_verified: 'Not verified',
  invitation_status_pending: 'Awaiting reply',
  invitation_status_accepted: 'Accepted',
  invitation_status_revoked: 'Revoked',
  invitation_status_expired: 'Expired',

  // Блок `WEB-1.3`. До волны 4 — машинный подстрочник (CR-008): присутствие и
  // непустота обязательны, содержимое проверке не подлежит.
  fleet_title: 'Company fleet',
  fleet_add: 'Add a vehicle',
  fleet_added: 'Vehicle added',
  fleet_add_already: 'This vehicle is already in the registry',
  fleet_vin: 'VIN code',
  fleet_tech_passport: 'Tech passport number',
  fleet_kind_label: 'Vehicle kind',
  fleet_body_type_label: 'Body type',
  fleet_withdraw: 'Withdraw from the registry',
  fleet_withdrawn_at: 'Withdrawal date',
  fleet_empty: 'The registry is empty for now',
  service_title: 'Vehicle service',
  service_state_label: 'Technical state',
  service_state_change: 'Change the state',
  service_records_title: 'Service log',
  service_record_add: 'Add a record',
  service_description: 'What was done, which units',
  service_parts: 'Spare parts',
  service_cost: 'Cost',
  service_currency: 'Currency',
  service_records_empty: 'No records yet',
  vin_claims_title: 'VIN release claims',
  vin_claim_create: 'Submit a claim',
  vin_claim_object: 'Object',
  vin_claim_window_ends_at: 'Objection window ends',
  vin_claims_empty: 'No claims yet',
  vehicle_kind_tractor: 'Tractor unit',
  vehicle_kind_trailer: 'Trailer unit',
  body_type_tarpaulin: 'Tarpaulin body',
  body_type_refrigerator: 'Refrigerator body',
  body_type_isothermal: 'Isothermal body',
  body_type_box: 'Box body',
  body_type_flatbed: 'Flatbed body',
  body_type_platform: 'Platform body',
  body_type_lowbed: 'Lowbed body',
  body_type_mega: 'Mega body',
  body_type_car_carrier: 'Car carrier body',
  body_type_tipper: 'Tipper body',
  body_type_walking_floor: 'Walking floor body',
  body_type_tank: 'Tank body',
  body_type_silo: 'Silo body',
  body_type_container_chassis: 'Container chassis body',
  body_type_bdf: 'BDF body',
  body_type_timber: 'Timber body',
  body_type_livestock: 'Livestock body',
  body_type_coil: 'Coil body',
  body_type_heavy_haul: 'Heavy haul body',
  body_type_extendable: 'Extendable body',
  repair_state_fault_detected: 'Fault detected',
  repair_state_in_repair: 'In repair',
  repair_state_repaired: 'Repaired',
  repair_state_ready: 'Ready to work',
  vehicle_status_active: 'In the registry',
  vehicle_status_withdrawn: 'Withdrawn from the registry',
  vin_claim_status_pending: 'Objection window open',
  vin_claim_status_objected: 'Objection filed',
  vin_claim_status_awaiting_admin: 'Awaiting staff decision',
  vin_claim_direction_outgoing: 'Our claim',
  vin_claim_direction_incoming: 'Claim against us',

  // Ключи блока `WEB-3.2` — страница публичного отслеживания по ссылке с PIN
  // (словарь §11 спецификации блока) и подписи двух перечней контракта.
  tracking_title: 'Vehicle delivery tracking',
  tracking_pin_hint: 'Enter the six-digit PIN the customer gave you together with the link. Without the PIN the page shows nothing.',
  tracking_pin_label: 'Six-digit PIN',
  tracking_pin_submit: 'Open',
  tracking_offline: 'No connection. Check the internet and try again.',
  tracking_offline_refresh: 'No connection — will refresh when the connection is back.',
  tracking_status_changed_at: 'Status changed',
  tracking_vehicle: 'Vehicle',
  tracking_route: 'Route',
  tracking_distance: 'Distance',
  tracking_transit: 'Transit',
  tracking_border_crossings: 'Border crossings',
  tracking_last_position: 'Last position',
  tracking_no_position: 'Position not received yet',
  tracking_open_map: 'Open in maps',
  tracking_photos: 'Vehicle handover',
  tracking_photo_open: 'Open photo',
  tracking_photo_plate: 'Licence plate',
  tracking_photo_close: 'Close',
  tracking_milestones: 'Stages',
  tracking_locked_title: 'The link is temporarily unavailable',
  tracking_retry: 'Enter the PIN again',
  tracking_gone_title: 'The link is no longer valid',
  tracking_map_title: 'Map: last position',
  work_status_CREATED: 'Created',
  work_status_ASSIGNED: 'Assigned',
  work_status_ACCEPTED: 'Accepted for execution',
  work_status_AT_PICKUP: 'At pickup',
  work_status_AT_HANDOVER: 'Vehicle handover',
  work_status_IN_TRANSIT: 'In transit',
  work_status_DELIVERED: 'Delivered',
  work_status_COMPLETED: 'Completed',
  work_status_CANCELLED: 'Cancelled',
  work_status_ARCHIVED: 'Archived',
  peregon_vehicle_kind_tractor: 'Tractor unit',
  peregon_vehicle_kind_tractor_with_trailer: 'Tractor unit with trailer',
  peregon_vehicle_kind_car: 'Passenger car',

  // Ключи блока `WEB-2.1` — кабинет логиста: «Мои объявления», форма
  // объявления, карточка с offer'ами и доской заказа (словарь §11
  // спецификации блока) и подписи девяти перечней контракта.
  // До волны 4 значения этого языка — подстрочник (CR-008).
  cargo_listings_title: 'Cargo listings',
  cargo_listings_create: 'Create listing',
  cargo_listings_more: 'Show more',
  cargo_listings_empty: 'No listings yet',
  cargo_listing_edit: 'Edit',
  cargo_listing_close: 'Close',
  cargo_listing_close_confirm: 'Close the listing? A closed listing does not return to the feed.',
  cargo_listing_km: 'km',
  cargo_listing_kg: 'kg',
  cargo_listing_days: 'days',
  cargo_listing_transit: 'Transit',
  cargo_listing_borders: 'Border crossings',
  cargo_listing_slots_free: 'Free',
  cargo_listing_slots_of: 'of',
  cargo_listing_fixed: 'Fixed price',
  cargo_listing_payment: 'Payment',
  cargo_listing_form_title_new: 'New cargo listing',
  cargo_listing_form_title_edit: 'Edit cargo listing',
  cargo_listing_form_origin: 'Loading city',
  cargo_listing_form_destination: 'Unloading city',
  cargo_listing_form_city_search: 'Start typing a city name',
  cargo_listing_form_loading_at: 'Loading date',
  cargo_listing_form_unload_by: 'Unload by',
  cargo_listing_form_vehicles_count: 'Vehicles needed',
  cargo_listing_form_cargo_type: 'Cargo',
  cargo_listing_form_weight: 'Weight per vehicle, kg',
  cargo_listing_form_adr: 'Dangerous goods (ADR)',
  cargo_listing_form_body_type: 'Body type',
  cargo_listing_form_body_subtype: 'Body subtype',
  cargo_listing_form_temperature_from: 'from',
  cargo_listing_form_temperature_to: 'to',
  cargo_listing_form_price: 'Price per vehicle',
  cargo_listing_form_currency: 'Currency',
  cargo_listing_form_negotiable: 'Price negotiable',
  cargo_listing_form_payment_method: 'Payment method',
  cargo_listing_form_payment_moment: 'Payment timing',
  cargo_listing_form_deferral_days: 'Deferral days',
  cargo_listing_form_comment: 'Comment',
  cargo_listing_form_submit: 'Publish',
  cargo_listing_form_save: 'Save changes',
  cargo_offers_title: 'Carrier offers',
  cargo_offer_accept: 'Approve',
  cargo_offer_decline: 'Decline',
  cargo_offer_decline_confirm: 'Decline the offer? The carrier will see the refusal.',
  cargo_offer_agrees: 'Agrees to your terms',
  cargo_offer_counter: 'Offers own price',
  cargo_offer_documents_verified: 'Documents verified',
  cargo_offer_vehicles: 'Vehicles',
  cargo_offer_price: 'Carrier price',
  cargo_offer_listing_price: 'Listing price',
  cargo_offer_expires: 'Respond by',
  cargo_offer_more: 'More offers',
  cargo_slots_title: 'Order board',
  cargo_slot_work: 'Work',
  listing_status_OPEN: 'Open',
  listing_status_TAKEN: 'All vehicles found',
  listing_status_CLOSED: 'Closed',
  listing_status_CANCELLED: 'Cancelled',
  listing_status_PENDING_REVIEW: 'Under review',
  listing_status_REJECTED: 'Rejected',
  cargo_offer_status_PENDING: 'Awaiting decision',
  cargo_offer_status_APPROVED: 'Approved — awaiting carrier confirmation',
  cargo_offer_status_CONFIRMED: 'Confirmed by carrier',
  cargo_offer_status_REJECTED: 'Declined',
  cargo_offer_status_WITHDRAWN: 'Withdrawn by carrier',
  cargo_offer_status_EXPIRED: 'Expired',
  cargo_offer_status_SUPERSEDED: 'No free vehicles left',
  cargo_offer_status_CANCELLED: 'All jobs cancelled',
  cargo_slot_status_OPEN: 'Free',
  cargo_slot_status_RESERVED: 'Awaiting carrier confirmation',
  cargo_slot_status_TAKEN: 'Taken',
  cargo_slot_status_CANCELLED: 'Cancelled',
  currency_USD: 'USD ($)',
  currency_UZS: 'UZS (sum)',
  currency_EUR: 'EUR (€)',
  payment_method_cash: 'Cash',
  payment_method_bank_transfer: 'Bank transfer',
  payment_moment_prepayment: 'Prepayment',
  payment_moment_on_unloading: 'On unloading',
  payment_moment_deferred: 'With deferral',
  loading_type_rear: 'Rear',
  loading_type_side: 'Side',
  loading_type_top: 'Top',
  loading_type_full_uncover: 'Full uncover',
  body_parameter_length_m: 'Length, m',
  body_parameter_width_m: 'Width, m',
  body_parameter_height_m: 'Height, m',
  body_parameter_volume_m3: 'Volume, m³',
  body_parameter_capacity_t: 'Capacity, t',
  body_parameter_loading_type: 'Loading type',
  body_parameter_temperature: 'Temperature, °C',
  body_parameter_cars_capacity: 'Car capacity',

  // Ключи блока `WEB-2.2`. Машинный подстрочник до волны 4 (CR-008): проверке
  // не подлежит, обязательны присутствие ключа и непустота значения.
  cargo_feed_title: 'Cargo feed',
  cargo_feed_filters: 'Filters',
  cargo_feed_apply: 'Apply',
  cargo_feed_reset: 'Reset',
  cargo_feed_more: 'Show more',
  cargo_feed_details: 'Details',
  cargo_feed_company_verified: 'Company verified',
  cargo_feed_adr: 'Dangerous goods (ADR)',
  cargo_feed_empty: 'No matching listings',
  cargo_feed_loading_from: 'Loading from',
  cargo_feed_loading_to: 'Loading until',
  cargo_feed_vehicles_min: 'Vehicles, at least',
  cargo_feed_weight_from: 'Weight from, kg',
  cargo_feed_weight_to: 'Weight up to, kg',
  cargo_feed_body_type: 'Body type',
  cargo_feed_temperature: 'Temperature control',
  cargo_feed_price_from: 'Price per vehicle from',
  cargo_feed_price_to: 'Price per vehicle up to',
  cargo_feed_currency: 'Price currency',
  cargo_feed_q: 'Keyword',
  cargo_feed_any: 'Any',
  cargo_feed_yes: 'Yes',
  cargo_feed_no: 'No',
  cargo_feed_cities_title: 'Departure cities',
  cargo_feed_cities_total: 'Listings in total',
  cargo_feed_date_hint: 'YYYY-MM-DD',
  cargo_feed_my_offer: 'Your company’s offer',
  cargo_feed_listing_no_right: 'Offers can be sent by an employee with the right to take cargo — the director grants it',
  cargo_feed_listing_unavailable: 'An offer on this listing cannot be sent from this company right now',
  cargo_feed_listing_agree: 'I agree to your terms',
  cargo_feed_listing_own_price: 'My own price',
  cargo_feed_listing_fixed_price: 'Fixed price',
  cargo_feed_listing_negotiable: 'Price is negotiable',
  cargo_feed_listing_submit: 'Send offer',
  cargo_feed_listing_price_amount: 'Your price per vehicle',
  cargo_offers_mine_title: 'My offers',
  cargo_offers_confirm: 'Confirm',
  cargo_offers_withdraw: 'Withdraw',
  cargo_offers_withdraw_confirm: 'Withdraw the offer? The logistician will no longer consider it.',
  cargo_offers_more: 'Show more offers',
  cargo_offers_agrees: 'Agreement to the terms',
  cargo_offers_counter: 'Own price',
  cargo_offers_vehicles: 'Vehicles',
  cargo_offers_empty: 'No offers yet',
  cargo_offers_price: 'Price per vehicle',
  cargo_offers_expires: 'Logistician to answer by',
  cargo_offers_confirm_by: 'Confirm by',
  cargo_offers_sender: 'Sent by',
  works_to_assign_title: 'Awaiting assignment',
  works_to_assign_empty: 'No works awaiting assignment',
  works_empty: 'No works yet',
  works_assign: 'Assign',
  works_replace: 'Replace',
  work_assignment_title: 'Vehicle and driver assignment',
  work_assignment_tractor: 'Tractor unit',
  work_assignment_trailer: 'Trailer',
  work_assignment_driver: 'Driver',
  work_assignment_no_trailer: 'No trailer',
  work_assignment_driver_busy: 'Busy',
  work_assignment_unnamed: 'Name not given',
  work_assignment_assign: 'Assign',
  work_assignment_replace: 'Replace',
  work_assignment_current: 'Currently assigned',
  work_assignment_assigned_at: 'Assigned at',
  work_assignment_history: 'Assignment history',
  work_assignment_history_empty: 'No replacements yet',
  work_assignment_assigned_by: 'Assigned by',
  work_assignment_replaced_by: 'Removed by',
  work_assignment_unavailable: 'Assignment and replacement are not available for this work right now',
  unassignable_reason_withdrawn: 'Withdrawn from the register',
  unassignable_reason_not_ready: 'Not ready for a trip',
  unassignable_reason_busy: 'Busy with another work',

  // Ключи блока `WEB-2.4`: карточка машины, водители фирмы, строки запчастей,
  // файл техпаспорта заявки, дата рождения и пол; подписи пола и типа документа.
  // До волны 4 — подстрочник (CR-008): проверке не подлежит.
  vehicle_card_title: 'Vehicle card',
  vehicle_photo_title: 'Vehicle photos',
  vehicle_photo_file: 'Choose a photo',
  vehicle_photo_add: 'Add a photo',
  vehicle_photo_delete: 'Delete',
  vehicle_photo_delete_confirm: 'Delete this vehicle photo?',
  vehicle_photo_empty: 'No photos yet',
  vehicle_fault_title: 'Open faults',
  vehicle_fault_empty: 'No open faults',
  vehicle_fault_author_unknown: 'Author not specified',
  vehicle_fault_comment: 'What is wrong with the vehicle',
  vehicle_fault_photos: 'Fault photos',
  vehicle_fault_add: 'Record a fault',
  vehicle_fault_history: 'All faults',
  vehicle_fault_open: 'Open',
  vehicle_fault_closed: 'Closed',
  vehicle_fault_history_empty: 'The vehicle has had no faults',
  drivers_title: 'Company drivers',
  drivers_age: 'Age:',
  drivers_name_unknown: 'Name not specified',
  drivers_not_specified: 'not specified',
  drivers_self_reported: 'Name, age and gender are self-reported',
  drivers_documents: 'Documents',
  drivers_empty: 'No drivers yet',
  service_part_add: 'Add a row',
  service_part_remove: 'Remove',
  service_part_name: 'Part name',
  service_part_quantity: 'Quantity',
  vin_claim_file_label: 'Tech passport file — photo or PDF',
  vin_claim_file_link: 'Tech passport',
  vin_claim_file_missing: 'Submitted without a file',
  profile_birth_date: 'Date of birth',
  profile_gender: 'Gender',
  profile_gender_unspecified: 'Not specified',
  profile_personal_note: 'Self-reported',
  profile_personal_hint: 'Visible to you; company members see only age and gender',
  profile_personal_save: 'Save',
  gender_male: 'Male',
  gender_female: 'Female',
  document_type_passport: 'Passport',
  document_type_driver_license: 'Driving licence',
  document_type_adr_certificate: 'ADR certificate',
  document_type_professional_certificate: 'Professional certificate',
  document_type_face_snapshot: 'Face snapshot',
  document_type_tachograph_card: 'Tachograph card',
  document_type_code95_card: 'Code 95 card',
  document_type_visa: 'Visa',
  document_type_registration_certificate: 'Registration certificate',
  expenses_title: 'Expenses',
  expenses_create: 'Record an expense',
  expenses_delete_confirm: 'Delete this expense?',
  expenses_empty: 'No expenses yet',
  expense_form_submit: 'Save the expense',
  expense_form_category: 'Category',
  expense_form_spent_on: 'Expense date',
  expense_form_vehicle: 'Vehicle',
  expense_form_receipt: 'Receipt — photo or PDF',
  expense_receipt_refreshed: 'The receipt link was renewed — open it again',
  expense_receipt_replace_hint: 'a new file replaces the previous one',
  payouts_title: 'Payouts',
  payouts_create: 'Record a payout',
  payouts_delete_confirm: 'Delete this payout?',
  payouts_empty: 'No payouts yet',
  payout_form_submit: 'Save the payout',
  payout_form_recipient: 'Recipient',
  payout_form_paid_on: 'Payout date',
  payout_recipient_unnamed: 'Name not given',
  payout_recipient_not_listed: 'Not among the company drivers',
  payout_recipient_unavailable: 'Recipient name unavailable',
  payout_recipient_loading: 'Loading recipient…',
  accounting_edit: 'Edit',
  accounting_delete: 'Delete',
  accounting_more: 'Show more',
  accounting_works_more: 'Show more works',
  accounting_filter_reset: 'Reset',
  accounting_filter_empty: 'No records for this filter',
  accounting_filter_any: 'All',
  accounting_work_fallback: 'Work',
  accounting_vehicle_fallback: 'Vehicle',
  accounting_vehicle_missing: 'Vehicle not found in the register',
  accounting_no_vehicle: 'No vehicle',
  accounting_no_work: 'No work',
  accounting_field_amount: 'Amount',
  accounting_field_currency: 'Currency',
  accounting_field_work: 'Work',
  accounting_field_comment: 'Comment',
  accounting_choose: 'Choose',
  accounting_form_close: 'Cancel',
  expense_category_diesel: 'Diesel fuel',
  expense_category_parking: 'Parking',
  expense_category_toll: 'Toll road',
  expense_category_service: 'Maintenance and repair',
  expense_category_other: 'Miscellaneous',
  state_retry: 'Retry',
  member_unnamed: 'Name not given',
  work_card_not_available: 'Work is not available',
  work_card_status: 'Status',
  work_card_price: 'Price',
  work_card_vehicle: 'Vehicle',
  work_card_vehicle_model: 'Model',
  work_card_auto_completed: 'Completed automatically',
  work_card_confirm: 'Confirm delivery',
  work_card_confirm_question: 'Confirm delivery? The work will be completed.',
  work_card_confirm_by: 'Confirm by',
  work_card_verified: 'Documents verified',
  work_card_not_verified: 'Documents not verified',
  work_card_parties: 'Parties',
  work_card_customer: 'Customer',
  work_card_executor: 'Carrier',
  work_card_assignment: 'Vehicle and driver',
  work_card_assignment_empty: 'Vehicle and driver not assigned yet',
  work_card_cargo: 'Cargo',
  work_card_cargo_type: 'Cargo type',
  work_card_cargo_loading: 'Loading date',
  work_card_cargo_weight: 'Weight',
  work_card_cargo_body: 'Body',
  work_card_history: 'History',
  work_card_history_empty: 'No history yet',
  work_card_track: 'Track',
  work_card_track_empty: 'No track points yet',
  work_card_track_thinned: 'Track thinned: not all points are shown',
  work_card_track_signal: 'Signal',
  work_card_track_age: 'Last point',
  work_card_track_minutes: 'min ago',
  work_card_tiles_failed: 'Map background unavailable; the track line is shown without it',
  work_card_chat: 'Work chat',
  work_card_message_text: 'Message',
  work_card_message_photo: 'Photo',
  work_card_message_send: 'Send',
  work_card_message_hidden: 'Message hidden',
  work_card_messages_more: 'Show earlier',
  work_card_messages_empty: 'No messages yet',
  work_card_thread: 'Driver thread',
  work_card_thread_caption: 'Director and dispatcher',
  work_card_thread_open: 'Open thread',
  work_card_files: 'Documents and receipts',
  work_card_files_empty: 'No files yet',
  work_card_file_kind: 'File type',
  work_card_file_description: 'Description',
  work_card_file_choose: 'File — photo or PDF',
  work_card_file_uploaded: 'File uploaded',
  work_card_file_edit: 'Edit description',
  work_card_file_save: 'Save',
  work_card_file_delete: 'Delete',
  work_card_file_delete_question: 'Delete this file?',
  work_card_photos: 'Work photos',
  work_card_photos_empty: 'No photos yet',
  work_card_photo_plate: 'Plate shot',
  work_card_tracking: 'Tracking link',
  work_card_tracking_create: 'Create link',
  work_card_tracking_revoke: 'Revoke link',
  work_card_tracking_revoke_question: 'Revoke the link? It stops working at once.',
  work_card_tracking_revoked: 'Link revoked',
  work_card_tracking_copy: 'Copy',
  work_card_tracking_copied: 'Copied',
  work_card_tracking_url: 'Address',
  work_card_tracking_pin: 'PIN',
  work_card_tracking_once: 'Shown once: save them now. A new link replaces the old one.',
  work_card_rating: 'Rating',
  work_card_rating_score: 'Score from 1 to 5',
  work_card_rating_comment: 'Comment',
  work_card_rating_send: 'Rate',
  work_card_rating_later: 'Later',
  work_card_rating_late: 'Rated after the deadline',
  work_card_claims: 'Cancellation and dispute',
  work_card_cancel_request: 'Request cancellation',
  work_card_cancel_category: 'Category',
  work_card_cancel_reason: 'Reason',
  work_card_cancel_send: 'Send request',
  work_card_cancel_respond_by: 'Respond by',
  work_card_cancel_accept: 'Accept cancellation',
  work_card_cancel_accept_question: 'Accept cancellation? The work will be cancelled.',
  work_card_cancel_decline: 'Decline',
  work_card_cancel_withdraw: 'Withdraw request',
  work_card_dispute: 'Dispute',
  work_card_dispute_open: 'Open dispute',
  work_card_dispute_statement: 'Statement',
  work_card_dispute_send: 'Submit statement',
  work_card_dispute_outcome: 'Outcome',
  work_card_dispute_guilty: 'Party at fault',
  work_card_dispute_note: 'Staff decision',
  work_card_dispute_message: 'Message to the dispute',
  work_card_dispute_message_send: 'Add message',
  work_signal_OK: 'Signal OK',
  work_signal_NO_DATA: 'No recent data',
  work_signal_LOST: 'Signal lost',
  work_file_kind_document: 'Document',
  work_file_kind_receipt: 'Receipt',
  work_file_kind_cmr: 'CMR',
  work_photo_phase_handover: 'Vehicle handover',
  work_photo_phase_delivery: 'Delivery',
  work_photo_phase_loading: 'Loading',
  work_photo_phase_unloading: 'Unloading',
  cancellation_category_VEHICLE_BREAKDOWN: 'Vehicle breakdown',
  cancellation_category_ACCIDENT: 'Accident',
  cancellation_category_OWNER_DEMAND: 'Owner demand',
  cancellation_category_DOCUMENTS_OR_BORDER: 'Documents or border',
  cancellation_category_EXECUTOR_FORCE_MAJEURE: 'Carrier force majeure',
  cancellation_category_CARGO_WITHDRAWN: 'Cargo withdrawn',
  cancellation_category_CARGO_NOT_READY: 'Cargo not ready',
  cancellation_category_OTHER: 'Other',
  cancellation_request_status_REQUESTED: 'Awaiting response',
  cancellation_request_status_ACCEPTED: 'Accepted',
  cancellation_request_status_REJECTED: 'Rejected',
  cancellation_request_status_WITHDRAWN: 'Withdrawn',
  cancellation_request_status_ESCALATED: 'Escalated to dispute',
  cancellation_request_status_LAPSED: 'Lapsed',
  dispute_status_OPEN: 'Open',
  dispute_status_IN_REVIEW: 'In review',
  dispute_status_ESCALATED: 'Escalated',
  dispute_status_RESOLVED: 'Resolved',
  dispute_outcome_CANCEL_WORK: 'Work cancelled',
  dispute_outcome_KEEP_WORK: 'Work continues',
  guilty_side_CUSTOMER: 'Customer',
  guilty_side_EXECUTOR: 'Carrier',
  guilty_side_NONE: 'No party at fault',
  dispute_author_customer: 'Customer',
  dispute_author_executor: 'Carrier',
  dispute_author_support: 'Support',
  work_card_file_uploading: 'Uploading file…',
  nav_label: 'Sections',
  nav_toggle: 'Menu',
  nav_sign_out: 'Sign out',
  nav_group_works: 'Works',
  nav_group_cargo: 'Cargo',
  nav_group_fleet: 'Fleet',
  nav_group_money: 'Money',
  nav_group_company: 'Company',
  works_column_status: 'Status',
  works_column_route: 'Route',
  works_column_cargo: 'Cargo',
  works_column_loading: 'Loading',
  works_column_vehicle: 'Vehicle',
  works_column_driver: 'Driver',
  works_column_action: 'Action',

  // Блок `WEB-3.5`: внутренний заказ.
  works_internal_new: 'New internal order',
  internal_work_form_title: 'Internal order',
  internal_work_form_weight: 'Weight, kg',
  internal_work_form_submit: 'Create order',
  work_internal: 'Internal',
  work_card_internal_cancel: 'Cancel order',
  work_card_internal_cancel_send: 'Cancel with this reason',
  work_card_internal_cancel_question: 'Cancel the order? The work will be cancelled and cannot be restored.',
};
